import React, { useState } from 'react';
import {
  Modal, Box, Typography, TextField, Button
} from '@mui/material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: '8px',
};

const RejectTeacherModal = ({ open, onClose, onSubmit }) => {
  const [reason, setReason] = useState('');

  const handleSubmit = () => {
    if (reason.trim()) {
      onSubmit(reason);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <Typography variant="h6" component="h2">
          Reason for Rejection
        </Typography>
        <TextField
          multiline
          rows={4}
          fullWidth
          margin="normal"
          label="Please provide a reason..."
          value={reason}
          onChange={(e) => setReason(e.target.value)}
        />
        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button variant="contained" color="error" onClick={handleSubmit} disabled={!reason.trim()}>
            Submit Rejection
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default RejectTeacherModal;